// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8671d805","455":"01acd60f","977":"dd21bdb4"}[chunkId] + ".chunk.js";
};